import {BaseGenericItemsStore, GenericItemsForm, GenericItemsUtils, IGetAllParams, MuiDataGrid, MuiIcons} from "@leap4/frontend";
import {urlService} from "../../../routing/urlsService"
import {connect, ConnectedProps} from "react-redux";
import {RootState} from "../../../../interfaces/root-state.interface";
import {useState} from "react";
import {getSavedFilterModel, saveFilterModel} from "../../../../utils/filterUtils";
import {IUser} from "./users.inteface";
import {userBaseUrl} from "../../../../config/generals";
import {tableNames} from "../../../../common/data/enums";

type GridColDef = MuiDataGrid.GridColDef;
const { Toc: TocIcon } = MuiIcons;


const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});


const connector = connect(mapStateToProps);


type PropsFromRedux = ConnectedProps<typeof connector>;

const fields = {
    isActive: 1,
    _id: 1,
    name: 1,
    email: 1,
    notification: 1,

}
const getParams: IGetAllParams = {
    fields,
    filter: {
        filter: {
            isDeleted: 0
        }
    }
}


let columns: GridColDef[];
let store: BaseGenericItemsStore<IUser & { _id: string, isActive: boolean }>

function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: userBaseUrl,
    }, fields, {
        name: {editLinkFunc: (_id: string) => urlService.editUser(_id)},
        isActive: {},
        updated: {},
        created: {},
    })
    store = storeAndColumns.store;
    columns = storeAndColumns.columns;
}


const UsersModule = (props: PropsFromRedux) => {
    const { selectedOrganization } = props;
    setStoreAndColumns();
    const [filterModel, setFilterModel] = useState(() => getSavedFilterModel(tableNames.USERS));

    const handleFilterChange = (newFilterModel) => {
        setFilterModel(newFilterModel || { items: [] });
        saveFilterModel(tableNames.USERS, newFilterModel);
    };
    return (
        <GenericItemsForm
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.users(),
                text: "user Dashboard",
                icon: <TocIcon/>
            }}
            getAllParams={getParams}
            organization={selectedOrganization}
            tableProps={{
                pageSize: 100,
                style: {minHeight: "75vh"},
                columnVisibilityModel: { _id: false },
                componentsProps: {
                    panel: {
                        sx: { top: '-200px !important' },
                    },
                },
                filterModel: filterModel,
                onFilterModelChange: handleFilterChange,
            }}
            createButton={{
                to: urlService.addUser(),
                text: "create user".toUpperCase()
            }}/>
    );
};


export default connector(UsersModule);
